import React, { useState, useEffect, useContext } from 'react';
import { ComponentProps } from '../../organisms/RFPComponent/RFPComponent.types';
import { StyledContactInformationDiv } from './index.styles';
import { serverData } from '../../organisms/RFPComponent/context';
import { iprops, contactInfo } from './index.types';
import { InputTextField } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { DropDownComponent } from '../DropDownComponent';

export const ContactInformation: React.FC<iprops> = (props: iprops) => {
  const { jsonContent }: ComponentProps = useContext(serverData);
  const pageType = jsonContent?.['instanceType'];
  const contactInformation = jsonContent?.['instance']?.contactInformation?.fieldSet
    ? [...jsonContent['instance']['contactInformation']['fieldSet']]
    : [];
  const defaultOption = { key: '', value: '' };
  const [selectedCountory, setSelectedCountory] = useState(defaultOption);
  const [eventPlannerInfo, setEventPlannerInfo] = useState(defaultOption);

  const onClear = (flag: boolean) => {
    if (flag) {
      setSelectedCountory(defaultOption);
      setEventPlannerInfo(defaultOption);
      const contactInformationArr = Array.from(
        document.getElementsByClassName('contactInformation') as HTMLCollectionOf<HTMLElement>
      )[0]?.children;
      for (let i = 0; i < contactInformationArr?.length; i++) {
        if (contactInformationArr[i]?.children[1]) {
          (contactInformationArr[i].children[1] as HTMLInputElement).value = '';
        }
      }
    }
  };

  useEffect(() => {
    onClear(props.onClear);
  }, [props.data, props.onClear]);

  return (
    <StyledContactInformationDiv data-component-name="m-trc-ContactInformation" data-testid="trc-ContactInformation">
      <div className="">
        <p className="mb-md-5 pb-2 pb-md-3 pt-5 t-title-alt-s t-rc-italic">
          {props.index}.{jsonContent?.['instance']?.contactInformation?.name}
        </p>
        {pageType === 'meetings' && (
          <div className="contactInformation offset-xl-2 row d-flex flex-wrap pb-md-5">
            {contactInformation.map((item: contactInfo, index: number) => {
              if (index < 7) {
                return (
                  <InputTextField
                    className={clsx(
                      'm-input-field',
                      'col-12 col-xl-6 col-md-8 mt-xl-4',
                      index === 3 || index === 4 ? 'col-xl-12' : '',
                      `rfp-${item['name']}`
                    )}
                    label={`${item['fieldName']}`}
                    showErrorMessage={props?.data[index + 1]?.isError}
                    messageToShow={item['errorMessage']}
                    isClickEnabled={true}
                    mandatory={item['mandatory']}
                    assignInputValue={props?.data[index === 0 ? 0 : index + 1]?.value ? true : false}
                    inputValue={props?.data[index === 0 ? 0 : index + 1]?.value}
                    messageClass={'error-text t-font-xs pt-1'}
                    setErrorHtml={props?.data[index + 1]?.isError}
                    isEmail={props?.data[index + 1]?.isEmail ?? false}
                    isBlurOn={false}
                    placeHolderText={item['placeholder']}
                    disabled={props.submitted}
                    getInputValue={(value: string) => {
                      props.onDataChange({
                        key: item['name'],
                        value: value,
                      });
                    }}
                  />
                );
              }
            })}

            <DropDownComponent
              className={clsx(`rfp-${contactInformation[7]?.name}`)}
              dropdownName={`${contactInformation[7]?.fieldName}`}
              dropdownLabel={`${contactInformation[7]?.fieldName}`}
              dropdownPlaceholder={`${contactInformation[7]?.placeholder ?? 'Select'}`}
              key={contactInformation[7]?.name}
              dropdownValue={contactInformation[7]?.inputOptions?.map((i: { name: string; value: string }) => {
                return {
                  key: i.value,
                  value: i.name,
                };
              })}
              inputValue={selectedCountory.value}
              isError={props?.data[8]?.isError}
              errorMessage={contactInformation[7]?.errorMessage}
              panelClassName="dropdown-panel"
              selectedOption={selectedCountory}
              mandatory={contactInformation[7]?.mandatory}
              disabled={props.submitted}
              onClick={(v: { key?: string; value?: string }) => {
                setSelectedCountory(JSON.parse(JSON.stringify(v)));
                props.onDataChange({
                  key: contactInformation[7]?.name,
                  value: v,
                });
              }}
              isTabletView={props?.isTabletView}
              iconAriaLabel={`select your option in ${contactInformation[7]?.name}`}
            />

            {contactInformation.map((item: contactInfo, index: number) => {
              if (index > 7) {
                return (
                  <InputTextField
                    className={clsx(
                      'm-input-field',
                      'mt-xl-4',
                      index > 9 ? 'col-12 col-xl-6 col-md-8' : '',
                      index === 8 ? 'col-12 col-xl-2 col-md-8' : '',
                      index === 9 ? 'col-12 col-xl-4 col-md-8' : '',
                      `rfp-${item['name']}`
                    )}
                    label={`${item['fieldName']}`}
                    showErrorMessage={props?.data[index + 1]?.isError}
                    messageToShow={item['errorMessage']}
                    isClickEnabled={true}
                    mandatory={item['mandatory']}
                    assignInputValue={props?.data[index + 1]?.value ? true : false}
                    inputValue={props?.data[index + 1]?.value}
                    messageClass={'error-text t-font-xs pt-1'}
                    type={`${index === 9 ? 'number' : 'text'}`}
                    setErrorHtml={props?.data[index + 1]?.isError}
                    isEmail={props?.data[index + 1]?.isEmail ?? false}
                    isBlurOn={false}
                    placeHolderText={item['placeholder']}
                    disabled={props.submitted}
                    getInputValue={(value: string) => {
                      props.onDataChange({
                        key: item['name'],
                        value: value,
                      });
                    }}
                  />
                );
              }
            })}
          </div>
        )}
        {pageType === 'weddings' && (
          <div className="contactInformation offset-xl-2 row d-flex flex-wrap pb-md-5">
            {contactInformation.map((item: contactInfo, index: number) => {
              if (index < 8) {
                return index === 1 ? (
                  <DropDownComponent
                    className={clsx(`rfp-${item?.name}`)}
                    dropdownName={`${contactInformation[1]?.fieldName}`}
                    dropdownLabel={`${contactInformation[1]?.fieldName}`}
                    dropdownPlaceholder={`${contactInformation[1]?.placeholder ?? 'Select'}`}
                    key={contactInformation[1]?.name}
                    mandatory={contactInformation[1]?.mandatory}
                    disabled={props.submitted}
                    dropdownValue={contactInformation[1]?.inputOptions?.map(
                      (i: { dependency: string; option: string }) => {
                        return {
                          key: i.option,
                          value: i.option,
                        };
                      }
                    )}
                    inputValue={eventPlannerInfo.value}
                    isError={props?.data[index]?.isError}
                    errorMessage={contactInformation[1]?.errorMessage}
                    panelClassName="dropdown-panel"
                    selectedOption={eventPlannerInfo}
                    onClick={(v: { key?: string; value?: string }) => {
                      setEventPlannerInfo(JSON.parse(JSON.stringify(v)));
                      props.onDataChange({
                        key: contactInformation[1]?.name,
                        value: v,
                      });
                    }}
                    isTabletView={props?.isTabletView}
                    iconAriaLabel={`select your option in ${contactInformation[1]?.name}`}
                  />
                ) : (
                  <InputTextField
                    className={clsx(
                      'm-input-field',
                      'col-12 col-xl-6 col-md-8 mt-xl-4',
                      index === 4 || index === 5 ? 'col-xl-12' : '',
                      `rfp-${item['name']}`
                    )}
                    label={`${item['fieldName']}`}
                    showErrorMessage={props?.data[index]?.isError}
                    messageToShow={item['errorMessage']}
                    isClickEnabled={true}
                    mandatory={item['mandatory']}
                    assignInputValue={props?.data[index]?.value ? true : false}
                    inputValue={props?.data[index]?.value}
                    messageClass={'error-text t-font-xs pt-1'}
                    setErrorHtml={props?.data[index]?.isError}
                    isEmail={props?.data[index]?.isEmail ?? false}
                    isBlurOn={false}
                    placeHolderText={item['placeholder']}
                    disabled={props.submitted}
                    getInputValue={(value: string) => {
                      props.onDataChange({
                        key: item['name'],
                        value: value,
                      });
                    }}
                  />
                );
              }
            })}

            <DropDownComponent
              className={clsx(`rfp-${contactInformation[8]?.name}`)}
              dropdownName={`${contactInformation[8]?.fieldName}`}
              dropdownLabel={`${contactInformation[8]?.fieldName}`}
              dropdownPlaceholder={`${contactInformation[8]?.placeholder ?? 'Select'}`}
              key={contactInformation[8]?.name}
              mandatory={contactInformation[8]?.mandatory}
              disabled={props.submitted}
              dropdownValue={contactInformation[8]?.inputOptions?.map((i: { name: string; value: string }) => {
                return {
                  key: i.value,
                  value: i.name,
                };
              })}
              inputValue={selectedCountory.value}
              isError={props?.data[8]?.isError}
              errorMessage={contactInformation[8]?.errorMessage}
              panelClassName="dropdown-panel"
              selectedOption={selectedCountory}
              onClick={(v: { key?: string; value?: string }) => {
                setSelectedCountory(JSON.parse(JSON.stringify(v)));
                props.onDataChange({
                  key: contactInformation[8]?.name,
                  value: v,
                });
              }}
              isTabletView={props?.isTabletView}
              iconAriaLabel={`select your option in ${contactInformation[8]?.name}`}
            />

            {contactInformation.map((item: contactInfo, index: number) => {
              if (index > 8) {
                return (
                  <InputTextField
                    className={clsx(
                      'm-input-field',
                      'mt-xl-4 ',
                      index > 10 ? 'col-12 col-xl-6 col-md-8' : '',
                      index === 9 ? 'col-12 col-xl-2 col-md-8' : '',
                      index === 10 ? 'col-12 col-xl-4 col-md-8' : '',
                      `rfp-${item['name']}`
                    )}
                    label={`${item['fieldName']}`}
                    showErrorMessage={props?.data[index]?.isError}
                    messageToShow={item['errorMessage']}
                    isClickEnabled={true}
                    mandatory={item['mandatory']}
                    assignInputValue={props?.data[index]?.value ? true : false}
                    inputValue={props?.data[index]?.value}
                    type={`${index === 10 ? 'number' : 'text'}`}
                    messageClass={'error-text t-font-xs pt-1'}
                    setErrorHtml={props?.data[index]?.isError}
                    isEmail={props?.data[index]?.isEmail ?? false}
                    isBlurOn={false}
                    placeHolderText={item['placeholder']}
                    disabled={props.submitted}
                    getInputValue={(value: string) => {
                      props.onDataChange({
                        key: item['name'],
                        value: value,
                      });
                    }}
                  />
                );
              }
            })}
          </div>
        )}
      </div>
    </StyledContactInformationDiv>
  );
};
